import Head from "next/head";
import EmailSignupBanner from "../../../components/EmailSignupBanner";
import Layout from "../../../components/Layout";
import { Button, Modal, Space, Text, Title} from '@mantine/core'
import { MenuId } from "../../../components/Header";
import styles from './public-vote.module.scss'
import { modals } from '@mantine/modals';

import { GetServerSideProps } from "next";
import { getGalleryImages } from "../../../lib/data";
import { RusAuthProps, RusContextProps, ImageData } from "../../../lib/definitions";

import { useEffect, useLayoutEffect, useRef, useState } from "react";


import { useWindowEvent } from '@mantine/hooks';


import Masonry from "react-responsive-masonry";
import { AspectBox } from "../../../components/AspectBox";
import Cookies from 'universal-cookie';
import axios from 'axios';
import Link from "next/link";
import Image from 'next/image';

import imgAandI from './images/a-and-i.png';
import imgCBPP from './images/cbpp.jpg';
import imgLogo from './images/logo.png';
import imgRP from './images/the-rp-high-res.jpg';
import EmailCapture from "../../../components/EmailCapture";
import imgCass from './images/cass_art_logo_1984_black-01.jpg';


const DEFAULT_NGG_ID = 103;

const artistRegEx= /'(.*)' by (.*)/;
const cookieName='po-25';

const ANNOUNCEMENT_URL="/the-winner-of-the-public-vote-for-raw-umber-studios-paint-off-2026/";

const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;
  
  type ImageDataEx = ImageData & {artist?:string, description?:string, title?:string};

  type Data = {
    images : ImageDataEx [],
    votingClosed: boolean
    resultsAnnounced: boolean  
    }

export default function PublicVote({data} : {data: Data & RusAuthProps & RusContextProps})
{
  let [lightboxImage, setLightboxImage] = useState<ImageDataEx | null>(null);
  let [showLightBoxFlag, setShowLightBoxFlag] = useState(false);
  let [images, setImages] = useState(data.images);

  let [imageWidth, setImageWidth] = useState(540);
  let [imageHeight, setImageHeight] = useState(540);

  let [voted, setVoted] = useState(false);

  const votingClosed = data.votingClosed;
  const cookies = new Cookies();

  function resizeImage()
  {
    if (lightboxImage)
    {
      let maxWidth = Math.max(window.innerWidth - 50,200);
      let maxHeight = Math.max(window.innerHeight - 125, 200);
      let width = maxWidth;
      let height = width * lightboxImage.height/lightboxImage.width;

      if (height>maxHeight)
      {
        height = maxHeight;
        width = height * lightboxImage.width / lightboxImage.height;
      }

      setImageWidth(width);
      setImageHeight(height);
      
    }
  }
  useIsomorphicLayoutEffect(()=>
  {
    resizeImage();
  }
  ,[lightboxImage]);

  useWindowEvent("resize", ()=>{resizeImage()});

  useEffect(()=>
  {

    /*
    async function retrievePoll()
      {
          let a = await axios.get(`${process.env.NEXT_PUBLIC_ELTON_ROUTE}/polls/${props.id}`);
          setPoll(a.data);
      }

      retrievePoll();*/
  
      if (cookies.get(cookieName)=='true')
      {
        setVoted(true);
      }

  }, []);


  function showLightBox(image: ImageDataEx)
  {
    setLightboxImage(image);
    setShowLightBoxFlag(true);
  }

  function closeLightbox()
  {
    setShowLightBoxFlag(false);
  }

  async function vote(x: ImageDataEx)
  {
    
    //no need to await or track errors
     axios.post('/n/api/image-vote',
    JSON.stringify({id: x.id, contest:'paint-off-2026'}),
    {
      headers:{'Content-Type': 'application/json'},
      withCredentials: true             
  });

    cookies.set(cookieName,"true", {expires: new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 800),  sameSite: "lax", path:"/"});
    setVoted(true);

    //okModalEx("Thank you!", `Thank you for voting for ${x.altText}!`);

    modals.open({
      title: <><b>Thank you for voting!</b></>,
      withCloseButton:true,
      closeOnClickOutside:true,

    
      children:
      (
        <div className={styles.container}>
          <EmailCapture/>
        </div>
      )
    })
}

  
  let url = `/n/api/thumbnails/${lightboxImage?.id}?w=1080&t=${lightboxImage?.updatedAt}`

    return(
        <>
        <Modal opened={showLightBoxFlag} onClose={closeLightbox} fullScreen closeOnEscape={false}>


      <div style={{display:"flex", width:"100%", height:"100%", justifyContent:"center"}}>
      <div className={styles.lightboxBorder} style={{width:imageWidth, height:imageHeight}}>
        {lightboxImage && <div style={{ width:"100%", height:"100%", backgroundImage:`url('${url}')`, backgroundSize:"contain", backgroundPosition:"center", backgroundRepeat:"no-repeat"}}></div>}
        </div>
     
        </div>
        <div style={{textAlign:'center', marginTop:10}}>
            <Button onClick={closeLightbox}>Close</Button>
            {(!voted && !votingClosed) && <Button ml='md' onClick={()=>vote(lightboxImage!)}>Vote for me!</Button>}
            </div>
        
        </Modal>
      
        <Layout menuId={MenuId.online} hideBanner={true}>

  
  <Head>
      <title>Vote for your favourite entry from our Paint Off 2026</title>
      <meta name="description" content="Your chance to choose your favourite entry from the Raw Umber Studios Paint Off"/>      
  </Head>
  <div className = {styles.mainContent}>
                  <h1>
                <Image priority src={imgLogo} width={300} alt='Raw Umber Studios Portrait Paint Off 2026'/>
                </h1>
  <h1 className={styles.h1}>Vote for your favourite entry from our Portrait Paint Off 2026</h1>
    <Text>In June 2026, seven amazing artists joined us at our studios in Stroud and spent a day painting from life. You can find out more about the day, and watch our documentary <Link href='/paint-off/2026/results'>here</Link>.</Text>
    <Text mt='md'>As well as a prize worth £2,500 awarded by our judges (Lizet Dingemans, Luca Indraccolo and Andrew James), we {data.resultsAnnounced?"awarded":"will award"} a second, £500 cash prize plus £250 of vouchers from our friends at <a href="https://cassart.co.uk" target="_none">Cass Art</a>, chosen by you the public.</Text>

      {votingClosed?
      (<Text  mt='md'>Voting has now closed.
      {data.resultsAnnounced && <> You can see the winner <Link href={ANNOUNCEMENT_URL}>here</Link></>}</Text>):
      (
    voted?
    <Text mt='md'>Thank you for voting!</Text>
    :
    <Text mt='md'>To vote, simply click on the image you like the most and tap the vote button. Voting closes on 19th November 2026 at 12 noon GMT</Text>
    )}
  </div>
  
  <Space h='lg'/>
  
<div style={{maxWidth:1000, marginLeft:"auto", marginRight:"auto", position:"relative"}}>



<Masonry columnsCount={2}>
{images.map(x => (
                <Tile key={x.id} image={x} vote={vote} showLightBox={showLightBox} canVote={!voted && !votingClosed}/>))}
</Masonry>



        

</div>

<div>
<Title order={3} mb='sm' ta="center">We&rsquo;d like to thank our supporters. In alphabetical order, they are:</Title>

<div style={{display:'flex', flexDirection:'row', flexWrap:'wrap', justifyContent:'center'}}>
    <div className={styles.logo}><a href='https://www.artistsandillustrators.co.uk/' target='_blank'><Image src={imgAandI} width={250} alt='Artists & Illustrators Logo'/></a></div>
    <div className={styles.logo} style={{marginLeft:32}}><a href='https://cassart.co.uk/' target='_blank'><Image src={imgCass} width={250} alt='Cass Art'/></a></div>
    <div className={styles.logo}><a href='https://www.thecbpp.org' target='_blank'><Image src={imgCBPP} width={250} alt='CBPP Logo'/></a></div>
    <div className={styles.logo}><a href='https://therp.co.uk/' target='_blank'><Image src={imgRP} width={250} alt='The RP Logo'/></a></div>

</div>
</div>

  <EmailSignupBanner/>
  </Layout>



        </>

    );
  }

  

  function Tile({image, showLightBox, vote, canVote} : {image:ImageDataEx, showLightBox: (x:ImageDataEx)=>void, vote: (x:ImageDataEx)=>void, canVote:boolean })
  {

    const [hover, setHover] = useState(false);

  async function mouseEnter(e: React.MouseEvent)
  {
    setHover(true);
  }

  async function mouseLeave(e: React.MouseEvent)
  {
    setHover(false);
  }


    let url = '';

    return <div onClick ={mouseEnter} onMouseEnter = {mouseEnter} onMouseLeave={mouseLeave} style={{margin:5}}>
       
        <AspectBox width= {image.width} height ={image.height} >
    <div style={{position:'relative', maxWidth:600}}>
        {/*eslint-disable-next-line @next/next/no-img-element*/}
        <img style = {{borderRadius:5}} alt = {image.altText} src={`/n/api/thumbnails/${image.id}?w=600&t=${image.updatedAt}`} width="100%"/>
        {hover && 
        <>
        <div style={{ textAlign:"center", position:'absolute', bottom:0, width:'100%', marginBottom:0, background:'#fffa'}}>
            {image.artist&&<><div className={styles.imageFooter}><i>
                <a href='#' className={styles.hoverInline} onClick={ (e)=>{e.preventDefault(); showLightBox(image)}}>   
   {image.title}
   </a></i> by {image.artist}</div></>}
                <div className={styles.votingBox}>
   {canVote && <>
   <Button className={styles.responsiveButton}  onClick={async x=> await vote(image)}>Vote for me!</Button>
   
   </>}
   </div>
            </div>
            </>}
 
    </div>
   
  
    </AspectBox>
    </div>
   
  }


export const getServerSideProps : GetServerSideProps = async (context)=>
{
  let competitionStatus = process.env.PAINT_OFF_2026_STATUS;

    /* possible statuses(those with * will be redirected):
    404 - Hidden *
    ENTRIES-OPEN
    ENTRIES-CLOSED
    EVENT-HAPPENED
    PUBLIC-VOTING *
    VOTING-CLOSED *
    ALL-DONE *
    */

    let votingClosed = false;
    let resultsAnnounced = false;

    if (competitionStatus=="ALL-DONE" || competitionStatus=="VOTING-CLOSED")
    {
        //return {redirect:{permanent:false, destination:'/paint-off/2025/results'}};
        votingClosed = true;
    }

    if (competitionStatus!="PUBLIC-VOTING" && !votingClosed)
    {
        return {notFound:true}
    }

    if (competitionStatus=="ALL-DONE")
    {
      resultsAnnounced = true;
    }
    
  var galleryId = DEFAULT_NGG_ID;

    if (process.env.PAINT_OFF_2026_NGG_ID)
    {
      galleryId=parseInt(process.env.PAINT_OFF_2026_NGG_ID);
    }
    
    let images=await getGalleryImages(galleryId);

    let imagesEx: ImageDataEx[] = images.map(
        (x)=>{        
            let i2 = artistRegEx.exec('' + x.altText);
            let artist='';
            let title='';

            if (i2)
            {
                artist = i2[2];
                title = i2[1];
            }

            let y :ImageDataEx = { description : x.description, artist:artist, title:title, ...x}
            return y;
        });


    return {
      props: {
        data: 
        { 
            images:imagesEx,
            votingClosed: votingClosed,
            resultsAnnounced: resultsAnnounced
        }
     }   

    }
}
